import type { IconName } from '../AppIcon';

export const notificationIconMap: Record<string, IconName> = {
  ClockInReminder: 'Clock',
  ClockOutReminder: 'LogOut',
  TimeSheetsCreated: 'CalendarClock',
  OvertimeVerification: 'Clock',
  BreakInNotification: 'Coffee',
  BreakOutNotification: 'Briefcase',
  LeaveRequest: 'Palmtree',
  LeaveRequestResponse: 'Palmtree',
  HolidayNotification: 'CalendarDays',
  OvertimeApprovalRequest: 'Clock',
  OvertimeApprovalResponse: 'Clock',
  UsersMissingClockInNotification: 'AlarmClock',
  EarlyClockOutNotification: 'LogOut',
  StillInBreakVerification: 'Coffee',
  LeaveRequestUndoResponse: 'Palmtree',
  PayslipGeneratedNotification: 'Receipt',
  AssetOtpVerification: 'KeyRound',
  AttendanceCorrectionRequestSubmitted: 'ClipboardCheck',
  AttendanceCorrectionRequestDecision: 'ClipboardCheck',
  ScheduleChanged: 'CalendarClock',
  OnboardingStarted: 'UserCheck',
  OnboardingStartDateReminder: 'UserCheck',
  OffboardingStarted: 'UserMinus',
  OffboardingLastDayReminder: 'UserMinus',
  InternalMovementInitiated: 'ArrowRightLeft',
  InternalMovementEffectiveDateReminder: 'ArrowRightLeft',
};
